var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "steps-con" }, [
    _c(
      "div",
      { staticClass: "step", class: { active: _vm.activeStep === 1 } },
      [
        _c("div", { staticClass: "number" }, [_vm._v("1")]),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [_vm._v("Allocatable Items")])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "border" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "step", class: { active: _vm.activeStep === 2 } },
      [
        _c("div", { staticClass: "number" }, [_vm._v("2")]),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [_vm._v("PO Required?")])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "border" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "step", class: { active: _vm.activeStep === 3 } },
      [
        _c("div", { staticClass: "number" }, [_vm._v("3")]),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [_vm._v("Select a ship to address")])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "border" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "step", class: { active: _vm.activeStep === 4 } },
      [
        _c("div", { staticClass: "number" }, [_vm._v("4")]),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [_vm._v("Special Instructions")])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "border" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "step", class: { active: _vm.activeStep === 5 } },
      [
        _c("div", { staticClass: "number" }, [_vm._v("5")]),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [_vm._v("Allocate Items")])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }